<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <!-- dialogVisible = true -->
        <el-button type="primary" @click="changeEventPayoutClick">Add</el-button>
        <el-button type="primary" @click="batchDelClick">Delete</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="eventPayoutList"
      border
      stripe
      style="width:100%;"
      height="80vmin"
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="OfferId" prop="offerId" align="center"></el-table-column>
      <el-table-column label="EventName" prop="eventName" align="center"></el-table-column>
      <el-table-column label="Payout" prop="payout" align="center"> </el-table-column>
      <el-table-column label="Operator" prop="createBy" align="center"></el-table-column>
      <el-table-column label="Operate Time" prop="createTime" align="center"></el-table-column>
      <el-table-column label="Option" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" @click="changeEventPayoutClick(scope.row)">Update</el-button>
          <el-button type="danger" @click="delClick(scope.row.id)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      class="block pagePanel"
      :pageTotal="eventPayoutTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :pageSize="pageSize"
      :currentPage="currentPage"
    ></pagination>

    <!-- 删除提示框 -->
    <el-dialog title="Delete" :visible.sync="delDialogVisible" width="300px" append-to-body>
      <div class="del-dialog-cnt">Confirm to delete ?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">cancel</el-button>
        <el-button type="primary" @click="delEventPayout">confirm</el-button>
      </span>
    </el-dialog>
    <!-- PB 配置模块框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      title="Event Payout"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        :model="eventPayout"
        label-position="left"
        label-width="95px"
        ref="eventPayoutForm"
        :rules="rules"
      >
        <el-row>
          <el-col :lg="11" :md="20">
            <el-form-item label="OfferId" prop="offerId">
              <el-input v-model="eventPayout.offerId" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="20" :offset="1">
            <el-form-item label="EventName" prop="eventName">
              <el-input v-model="eventPayout.eventName" placeholder="eventName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="11" :md="20">
            <el-form-item label="Payout" prop="payout">
              <el-input v-model="eventPayout.payout" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeEventPayout()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '@/components/pagination';

  import { getEventPayoutList, updateEventPayout, deleteEventPayout } from 'api/affiliate/detail';
  const defaultEventPayout = {
    offerId: '',
    eventName: '',
    payout: '',
  };
  export default {
    components: {
      Pagination,
    },
    props: {
      affiliateId: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        selectIds: [],
        eventPayoutTotal: null,
        currentPage: 1,
        pageSize: 20,
        delDialogVisible: false,
        eventPayoutList: [],
        rules: {
          offerId: [
            {
              required: true,
              message: 'OfferId must be specified',
            },
          ],
          eventName: [
            {
              required: true,
              message: 'eventName must be specified',
            },
          ],
          payout: [
            {
              required: true,
              message: 'payout must be specified',
            },
          ],
        },
        dialogVisible: false,
        eventPayout: {},
      };
    },
    mounted() {
      this.getEventPayoutList();
    },
    methods: {
      getEventPayoutList(curPage) {
        if (curPage) {
          this.currentPage = curPage;
        }
        const param = {
          page: this.currentPage,
          pageSize: this.pageSize,
          affiliateId: this.affiliateId,
        };
        getEventPayoutList(param).then((response) => {
          if (response.code === 200) {
            this.eventPayoutList = response.result;
            this.eventPayoutTotal = response.total;
          }
        });
      },
      changeEventPayoutClick(row) {
        this.eventPayout = Object.assign({}, defaultEventPayout, row);
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.eventPayoutForm.clearValidate();
        });
      },
      delEventPayout(id) {
        const ids = id ? id : this.selectIds.join(',');
        const params = {
          affiliateId: this.affiliateId,
          ids,
        };
        deleteEventPayout(params).then((response) => {
          if (response.code === 200) {
            this.$message({
              message: 'Delete Success',
              type: 'success',
            });
            this.getEventPayoutList();
          } else {
            this.$message.error('Delete Error:' + response.message);
          }
        });
        this.delDialogVisible = false;
      },
      changeEventPayout() {
        this.$refs.eventPayoutForm.validate((valid) => {
          if (valid) {
            let param = {
              ...this.eventPayout,
              affiliateId: this.affiliateId,
            };
            const typeStr = param.id ? 'Update' : 'Add';
            updateEventPayout(param).then((response) => {
              if (response.code === 200) {
                this.$message({
                  message: typeStr + ' Success',
                  type: 'success',
                });
                this.getEventPayoutList();
              } else {
                this.$message.error(typeStr + ' Error:' + response.message);
              }
            });
            this.dialogVisible = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      delClick(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.delEventPayout(id);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
      batchDelClick() {
        if (this.selectIds.length <= 0) {
          this.$message.warning('你还没有选择要删除的数据哦~');
          return;
        }
        this.delDialogVisible = true;
      },
      handleSelectionChange(val) {
        this.selectIds = val.map((item) => item.id);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getEventPayoutList();
      },
    },
  };
</script>

<style></style>
